module.exports = __webpack_public_path__ + "static/media/des-header.cae8326f.png";